import { takeEvery, call, all, fork } from "redux-saga/effects";
import { SAVE_ANSWERS } from "./action";
import reduxSagaFirebase from "../../common/reduxSagaFirebase";

export function* onSaveAnswersSaga(action) {
  const answers = action.payload.answers;
  const uid = action.payload.uid;
  yield call(reduxSagaFirebase.database.update, `answers/${uid}`, answers);
}

export function* saveAnswersSaga() {
  yield takeEvery(SAVE_ANSWERS, onSaveAnswersSaga);
}

export function* singleTestSaga() {
  yield all([fork(saveAnswersSaga)]);
}
